module.exports = __webpack_public_path__ + "static/media/xaverian-brothers.7ca2988f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/main/xaverian-brothers.jpg
// module id = 733
// module chunks = 0